import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCheckboxSmall = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		x: 2.7,
		y: 2.7,
		width: 12.6,
		height: 12.6,
		rx: 3.3,
		fill: "currentColor",
		stroke: "#C5C5C5",
		strokeWidth: 1.4
	})
});
export default SvgIconCheckboxSmall;
